<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
          <v-row class="justify-center mt-3">
            <v-col cols="4">
                <v-text-field
                v-model="form.filters.formacao"
                label="Formação"
                outlined
                dense
                ></v-text-field>
            </v-col>
            <sigfoco-date-picker
                :cols="3"
                label="Data de Realização"
                v-model="form.filters.dataRealizacao"
                removeIcon
                outlined
                dense
            ></sigfoco-date-picker>
          </v-row>
          <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                text="Buscar"
                icon="mdi-magnify"
                @click="buscarListaPresenca()"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Limpar"
                icon="mdi-eraser"
                @click="resetForm()"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5"
          :headers="table.headers"
          :items="table.itens"
          :items-per-page="10"
          :footer-props="$footerProps"
        >
          <template v-slot:[`item.dataRealizacao`]="{ item }">
            {{ $formatarData(item.dataRealizacao) }}
          </template>
          <template v-slot:[`item.acoes`]="{ item }">
            <sigfoco-tooltip
              text="Visualizar"
              icon="mdi-eye-outline"
              small
              @click="openDialogVisualizarListaPresenca(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              :text="
                !item.passouSeteDias && !item.presencaConcluida
                  ? 'Preencher Lista de Presença'
                  : (item.presencaConcluida
                      ? 'Baixar Lista de Presença'
                      : 'Fora do prazo')"
              :icon="
                !item.passouSeteDias && !item.presencaConcluida
                  ? 'mdi-format-list-bulleted'
                  : (item.presencaConcluida
                      ? 'mdi-arrow-down'
                      : 'mdi-close')"
              small
              @click="openDialogPrencherListaPresenca(item)"
            />
          </template>
        </v-data-table>
      </v-container>
        <CadastrarListaPresencaDialog
            :visible="dialogPreencherListaPresenca.visible"
            :content="dialogPreencherListaPresenca.content"
            :edit="dialogPreencherListaPresenca.edit"
            @onClose="dialogPreencherListaPresenca.close()"
            @onSave="buscarListaPresenca()"
        ></CadastrarListaPresencaDialog>
        <VisualizarListaPresencaDialog
            v-if="dialogVisualizarListaPresenca.visible"
            :visible="dialogVisualizarListaPresenca.visible"
            :content="dialogVisualizarListaPresenca.content"
            @onClose="dialogVisualizarListaPresenca.close()"
        ></VisualizarListaPresencaDialog>
    </div>
  </template>
  
  <script>
  import { ListaPresenca } from "~/commons/classes/lista-presenca";
  import { Dialog } from "~/commons/classes/dialog";
  import ListaPresencaService from "~/services/manter-lista-presenca.service";
  import VisualizarListaPresencaDialog from "./dialogs/VisualizarListaPresencaDialog.vue";
  import CadastrarListaPresencaDialog from "./dialogs/CadastrarListaPresencaDialog.vue";
  export default {
    name: "ManterListaPresencaView",
    mixins: [ListaPresencaService],
    components: {
      VisualizarListaPresencaDialog,
      CadastrarListaPresencaDialog
    },
    data: () => ({
      dialogVisualizarListaPresenca: Dialog.Build(),
      dialogPreencherListaPresenca: Dialog.Build(),
      form:{
        filters: {
          formacao: null,
          dataRealizacao: null,
        },
      },
      opcoesStatus: [
        { value: true, descricao: "Presente" },
        { value: false, descricao: "Ausente" },
      ],
      table: {
        headers: [
            { text: "Formação", align: "center", value: "formacao" },
            { text: "Data de Realização", align: "center", value: "dataRealizacao" },
            { text: "Carga Horária", align: "center", value: "cargaHoraria" },
            { text: "Ações", align: "center", value: "acoes", sortable: false },
        ],
        itens: [],
      }
    }),
    methods: {
      
      resetForm() {
          this.$resetForm();
          this.form.filters.dataRealizacao = null;   
          this.$nextTick(() => {
            this.$set(this.form.filters, 'dataRealizacao', null);
          });
          this.table.itens = [];
          this.form.filters.ativo = null;
      },
      openDialogVisualizarListaPresenca(listaPresenca) {
          this.$visualizar(listaPresenca.id).then(
          ({ data }) => this.dialogVisualizarListaPresenca.open(new ListaPresenca(data.item))
          );
      },
      openDialogPrencherListaPresenca(listaPresenca) {
        if (listaPresenca.passouSeteDias && !listaPresenca.presencaConcluida) {
          this.$notifyError("A lista de presença não está disponível para download, pois não foi preenchida pelo responsável pela formação.");
          return;
        }
          this.$visualizar(listaPresenca.id).then(
          ({ data }) => this.dialogPreencherListaPresenca.open(new ListaPresenca(data.item))
          );
      },
      buscarListaPresenca() {
        const params = {
            formacao: this.form.filters.formacao,
            dataRealizacao: this.form.filters.dataRealizacao,
        };
        this.$buscar({ params }).then(({ data }) => {
          this.table.itens = data.itens;
          }
        );
      },
    },
  }
</script>